/**
 * Desktop direct purchase.
 *
 * The button lives in its own plain form that posts to Shopify's /cart/add with
 * a `return_to` of /checkout - Shopify's documented one-request path from a
 * product page to checkout. This module does three things and nothing more:
 *
 *   1. copies the live variant id and quantity out of the section's real
 *      product form at submit time, so a variant or quantity change can never
 *      leave a stale value behind;
 *   2. swaps the label to a busy state;
 *   3. blocks a second submit, so an impatient double click cannot create two
 *      carts.
 *
 * It never touches Shopify Checkout, never asserts which payment method the
 * buyer will end up using, and never simulates a wallet button.
 */

const SUBMITTED = new WeakSet();

function sync(form) {
  const source = document.getElementById(form.dataset.sourceForm);
  if (!source) return;

  const variantField = form.querySelector('[data-asx-buy-now-variant]');
  const liveVariant = source.querySelector('[name="id"]');
  if (variantField && liveVariant && liveVariant.value) {
    variantField.value = liveVariant.value;
  }

  const quantityField = form.querySelector('[data-asx-buy-now-quantity]');
  const liveQuantity = source.querySelector('[name="quantity"]');
  if (quantityField && liveQuantity && liveQuantity.value) {
    quantityField.value = liveQuantity.value;
  }
}

function onSubmit(event) {
  const form = event.currentTarget;

  if (SUBMITTED.has(form)) {
    event.preventDefault();
    return;
  }

  sync(form);
  SUBMITTED.add(form);

  const button = form.querySelector('button[type="submit"]');
  if (!button) return;

  button.setAttribute('aria-disabled', 'true');
  if (button.dataset.busyLabel) button.textContent = button.dataset.busyLabel;

  // Disabling in the handler itself would cancel the submission that is still
  // being dispatched, so the guard lands on the next frame instead.
  requestAnimationFrame(() => {
    button.disabled = true;
  });
}

function init(root) {
  root.querySelectorAll('[data-asx-buy-now]').forEach((form) => {
    if (form.dataset.asxBuyNowBound) return;
    form.dataset.asxBuyNowBound = 'true';
    form.addEventListener('submit', onSubmit);
  });
}

init(document);

// Horizon re-renders product sections on variant change; pick up the new form.
document.addEventListener('shopify:section:load', (event) => init(event.target));
